export const COMPARISON_QUERY_KEYS = ["compareBy", "compareGroups", "compare"] as const;
